import { render, staticRenderFns } from "./SurveyOption.vue?vue&type=template&id=c5aa9db4&"
import script from "./SurveyOption.vue?vue&type=script&lang=js&"
export * from "./SurveyOption.vue?vue&type=script&lang=js&"
import style0 from "./SurveyOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports